export default __webpack_public_path__ + "static/media/facture_nav_icon.a04dcf08.svg";